exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.line[data-v-106f4ed2]{\n  text-align: center;\n}\n", ""]);

// exports
